<template>
    <div id="app"
        class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
        <HeadNav :selectedLanguage="selectedLanguage" page="blogs" :gotodownload="gotodownload" :apk="apk" />
        <Breadcrumb />

        <div id="page" class="site grid-container container hfeed">
            <div id="content" class="site-content">
                <div id="primary" class="content-area">
                    <div class="markdown-content">
                        <h1>Show Blue Ticks After Reply: A Smart Read Receipt Feature in GBWhatsApp</h1>

                        <img src="@/assets/blog-1.webp"
                            alt="Blue Ticks After Reply">

                        <p>In today's highly popular era of instant messaging, "read but not reply" often leads to
                            unnecessary social pressure. To solve this problem, <a
                                href="/">GBWhatsApp</a> provides a large number of advanced
                            privacy features. Among them, Show Blue Ticks After Reply is a setting that is very popular
                            among users.</p>

                        <p>This article will comprehensively analyze this practical function from aspects such as its
                            functional meaning, usage scenarios, activation methods, and precautions.</p>

                        <h2>What is Show Blue Ticks After Reply?</h2>

                        <p>Show Blue Ticks After Reply. In Chinese, it can be understood as "the read blue tick is
                            displayed only after the reply." After enabling this function:</p>

                        <ul>
                            <li>Even if you have viewed the message sent by the other party, before you reply, the other
                                party can only see the gray checkmark (delivered).</li>
                            <li>Only after you send a reply message will the system display the read status as a blue
                                checkmark.</li>
                        </ul>

                        <p>This means that you can freely view the message without exposing the "read status", truly
                            controlling the communication pace.</p>

                        <h2>What Practical Problems Does this Function Solve?</h2>

                        <h3>Reduce the social pressure of "read but not reply".</h3>

                        <p>In regular WhatsApp, as soon as you open a message, a blue checkmark will immediately appear,
                            making it easy for the other party to think that you are "deliberately not replying". This
                            function enables you to read first, then think, and finally reply, avoiding unnecessary
                            misunderstandings.</p>

                        <h3>More suitable for busy or fragmented usage scenarios.</h3>

                        <p>During work, study or meetings, you may only be able to quickly check messages but not reply
                            immediately. Show Blue Ticks After Reply allows you to check messages with peace of mind
                            even when you are busy.</p>

                        <h3>Enhance privacy control rights.</h3>

                        <p>The read status essentially belongs to personal privacy. Through this feature, GBWhatsApp
                            gives users greater autonomy over "when to let the other party know you have read".</p>

                        <h2>The Core Advantage of Show Blue Ticks After Reply</h2>

                        <p>Compared with the official WhatsApp, this feature has obvious advantages:</p>

                        <ul>
                            <li>Precise control of read display timing</li>
                            <li>No impact on normal message receiving and sending</li>
                            <li>Can be used simultaneously with other privacy features (such as hiding online status,
                                hiding typing in progress)</li>
                            <li>No prompt to the other party, natural experience Compared to "completely closing the
                                blue checkmark", this feature is more flexible and better meets real social needs.</li>
                        </ul>

                        <h2>How to Enable this Feature in GBWhatsApp?</h2>

                        <p>The activation steps are very simple and suitable for novice users:</p>

                        <ol>
                            <li>Open GBWhatsApp,</li>
                            <li>Click the three-dot menu in the upper right corner to enter GB Settings,</li>
                            <li>Select Privacy & Security,</li>
                            <li>Find the Blue Ticks/Read Receipts related option</li>
                            <li>Check it Show Blue Ticks After Reply takes effect upon return (usually no need to
                                restart).</li>
                        </ol>

                        <p>After the Settings are completed, this function will take effect by default in all chats.</p>

                        <h2>The Difference from Other Read Receipt Functions</h2>

                        <table>
                            <thead>
                                <tr>
                                    <th>Feature Type</th>
                                    <th>What the Other Person Sees</th>
                                    <th>Flexibility</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Official WhatsApp Blue Ticks</td>
                                    <td>Display upon opening</td>
                                    <td>Low</td>
                                </tr>
                                <tr>
                                    <td>Completely Disable Blue Ticks</td>
                                    <td>Blue ticks never appear</td>
                                    <td>Medium</td>
                                </tr>
                                <tr>
                                    <td>Show Blue Ticks After Reply</td>
                                    <td>Display only after a reply</td>
                                    <td>High</td>
                                </tr>
                            </tbody>
                        </table>


                        <p>It can be seen that Show Blue Ticks After Reply is the most balanced and humanized choice
                            among the three.</p>

                        <h2>Matters Needing Attention when Using</h2>

                        <ul>
                            <li>This function is only applicable to modified applications such as GBWhatsApp.</li>
                            <li>If you enable "Completely close the blue checkmark" at the same time, it may overwrite
                                this function.</li>
                            <li>The read mechanism in group chats may be slightly different from that in private chats.
                            </li>
                            <li>Frequent use of privacy features may be noticed by some contacts as behavioral changes,
                                but they will not receive system prompts.</li>
                        </ul>

                        <p>Only by using them in combination can the best experience be achieved.</p>

                        <h2>Who is the Most Suitable to Use this Function?</h2>

                        <p>The following users are particularly suitable for enabling Show Blue Ticks After Reply:</p>

                        <ul>
                            <li>busy office workers with a lot of messages</li>
                            <li>users who do not want to be urged to reply</li>
                            <li>people who value privacy and social boundaries</li>
                            <li>users who use GBWhatsApp for business or customer communication</li>
                        </ul>

                        <h2>Final Thoughts</h2>

                        <p>Show Blue Ticks After Reply is a seemingly simple but highly practical feature in GBWhatsApp.
                            It not only alleviates the social pressure brought by instant messaging, but also enables
                            users to regain the initiative in communication.</p>

                        <p>If you wish to read messages more freely in a chat, reply to content more calmly, and protect
                            your personal privacy at the same time, then this feature is well worth enabling.</p>
                    </div>
                </div>
            </div>
        </div>
        <PostNav />

        <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
            Download GBWhatsapp APK
        </div>
    </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import Breadcrumb from '@/components/Breadcrumb.vue';
import HeadNav from '@/components/HeadNav.vue';
import PostNav from '@/components/PostNav.vue';

export default {
    name: 'Home',
    components: {
        Breadcrumb,
        HeadNav,
        PostNav,
    },
    data() {
        return {
            pageName: 'home',
            selectedLanguage: 'en',
        };
    },
    mounted() {
        this.from = this.$global.GetQueryString('from') || this.from;
        this.filename = this.$global.GetQueryString('filename') || this.filename;
        console.log(this.$global.GetQueryString('from'));
        if (this.$global.GetQueryString('from')) {
            this.getAPK();
        } else {
            this.getOfficalApk();
        }
    },
    methods: {
        goto(name) {
            // window.location.href = url;
            this.$router.push({
                name: `${name}`
            });
        },
        downloadfrom(reason) {
            this.download();
            this.$logEvent(`download_from_${reason}`, 'download');
            // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
        },
        getAPK() {
            this.$server
                .getAPPInfo({
                    promotionChannel: this.from,
                    promotionName: this.filename,
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.apk = res.data.apk;
                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }
                        this.lastupdate = res.data.promotion.updateTime;
                        this.votes = res.data.promotion.totalCount;
                        this.rating = res.data.promotion.score;
                        console.log('apk getted');
                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        gotodownload() {
            console.log(this.apk);
            // this.showapk = true
            if (this.apk) {
                this.$global.download(this.apk);
            }
        },
        jump(url) {
            if (url && url.startsWith('/')) {
                this.$router.push(this.$global.normalizeInternalPath(url));
                return;
            }
            window.location.href = url;
        },
        gotoHome(page) {
            this.$router.push({
                name: `${this.selectedLanguage}-${page}`
            });
        }
    },
};
</script>

<style scoped>
.markdown-content {
    padding: 20px;
    line-height: 1.6;
    margin: 0 auto;
    max-width: 1000px;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.markdown-content h1 {
    font-size: 2em;
    margin: 0.67em 0;
    border-bottom: 2px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
}

.markdown-content h2 {
    font-size: 1.5em;
    margin: 0.75em 0;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
    color: #2d3748;
    margin-top: 40px;
}

.markdown-content h3 {
    font-size: 1.25em;
    margin: 0.83em 0;
    color: #2d3748;
    margin-top: 40px;
}

.markdown-content h4 {
    font-size: 1em;
    margin: 1em 0;
    color: #2d3748;
}

.markdown-content p {
    margin: 1em 0;
}

.markdown-content ul,
.markdown-content ol {
    margin: 1em 0;
    padding-left: 2em;
}

.markdown-content li {
    margin: 0.5em 0;
}

.markdown-content blockquote {
    border-left: 4px solid #ddd;
    padding-left: 1em;
    margin: 1em 0;
    color: #666;
}

.markdown-content hr {
    margin: 2em 0;
    border: none;
    border-top: 1px solid #eee;
}

.markdown-content pre {
    background: #f5f5f5;
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
}

.markdown-content code {
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 0.9em;
}

.markdown-content img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 1em 0;
}

.markdown-content a {
    color: #667eea;
    text-decoration: none;
}

.markdown-content a:hover {
    text-decoration: underline;
}

.markdown-content strong {
    font-weight: 700;
}

.markdown-content em {
    font-style: italic;
}

.markdown-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5em 0;
    font-size: 1em;
}

.markdown-content th,
.markdown-content td {
    padding: 12px 15px;
    text-align: left;
    border: 1px solid #e8e8e8;
}

.markdown-content th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #2d3748;
}

.markdown-content tr:nth-child(even) {
    background-color: #fafbfc;
}

.markdown-content tr:hover {
    background-color: #f5f5f5;
}
</style>
